import React from 'react';

const S = {
  page: { minHeight: '100vh', background: '#0f1115', padding: '40px 16px' },
  wrap: { maxWidth: '720px', margin: '0 auto' },
  header: { textAlign: 'center', marginBottom: '40px' },
  logo: { fontSize: '36px', fontWeight: 900, color: '#ffffff', marginBottom: '8px' },
  title: { fontSize: '28px', fontWeight: 800, color: '#fff', marginBottom: '8px' },
  content: { background: '#1a1d24', borderRadius: '16px', padding: '32px', border: '1px solid #2a2d35' },
  text: { color: '#9ca3af', fontSize: '14px', lineHeight: 1.8, marginBottom: '24px' },
  section: { color: '#fff', fontSize: '16px', fontWeight: 700, marginTop: '32px', marginBottom: '12px' },
  back: { display: 'inline-block', marginTop: '24px', color: '#00e701', textDecoration: 'none', fontSize: '14px', fontWeight: 600 },
};

export default function TOS() {
  return (
    <div style={S.page}>
      <div style={S.wrap}>
        <div style={S.header}>
          <div style={S.logo}>💎 BetonMines</div>
        </div>

        <div style={S.content}>
          <h1 style={{ ...S.title, fontSize: '24px', marginBottom: '24px' }}>Terms of Service</h1>

          <p style={S.text}>
            <strong style={{ color: '#fff' }}>BetonMines</strong> ("we", "us", "our") is the owner and operator of this website and any affiliated websites and related mobile versions ("BetonMines"). BetonMines is an entertainment platform that allows users to play a variety of games ("Games") using Balance, an internal virtual currency that represents Robux value.
          </p>

          <p style={S.text}>
            Users deposit Robux to receive Balance, play Games using Balance, and may withdraw their Balance as Robux.
          </p>

          <p style={S.text}>
            <strong style={{ color: '#fff' }}>BetonMines is not affiliated with, endorsed by, or sponsored by Roblox Corporation.</strong> "Roblox," "Robux," and all related names, marks, and logos are trademarks of Roblox Corporation, used herein solely for identification purposes.
          </p>

          <h2 style={S.section}>1. Acceptance</h2>
          <p style={S.text}>
            By accessing BetonMines or using the Services, you accept and agree to our website policies, including these Terms of Service, and you certify to us that (i) you are eighteen (18) years of age or older, (ii) you have the legal capacity to enter into and agree to these Terms of Service, (iii) you are using the Services freely, voluntarily, willingly, and for your own personal enjoyment, and (iv) you will only provide accurate and complete information to us.
          </p>

          <h2 style={S.section}>2. Right to Revise</h2>
          <p style={S.text}>
            We reserve the right to revise these Terms of Service at any time. You agree that we have this unilateral right, and that all modifications or changes are in force and enforceable immediately upon posting.
          </p>

          <h2 style={S.section}>3. Not a Gambling Service</h2>
          <p style={S.text}>
            We are not a gambling service. We offer entertaining online Games that fall outside the prohibitions imposed by state and federal gambling laws.
          </p>
          <p style={S.text}>
            Balance is an internal virtual currency with no real-world cash value. Users deposit Robux (a virtual currency with no cash value under the Roblox Terms of Use) to receive Balance, play Games using Balance, and may withdraw their Balance as Robux. Because Robux and Balance are virtual currencies with no real-world cash value, nothing of real-world value is at stake or can be won at any point in this process.
          </p>
          <p style={S.text}>
            You agree not to use the Services if doing so would violate the laws of your state, province, or country. It is your sole and absolute responsibility to comply with all applicable laws, and you assume all risk in using the Services. You understand and agree that the Services are for entertainment purposes only.
          </p>

          <h2 style={S.section}>4. User Conduct</h2>
          <p style={S.text}>
            You agree not to use the Services for any unlawful purpose or in any way that could damage, disable, overburden, or impair the Services. You may not attempt to gain unauthorized access to any part of the Services.
          </p>

          <h2 style={S.section}>5. Disclaimer</h2>
          <p style={S.text}>
            THE SERVICES ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. WE DO NOT GUARANTEE THAT THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE.
          </p>

          <h2 style={S.section}>6. Contact</h2>
          <p style={S.text}>
            If you have any questions about these Terms of Service, please contact us through our support channels.
          </p>

          <p style={{ ...S.text, marginTop: '32px', fontSize: '12px', color: '#6b7280' }}>
            Last updated: April 7, 2026
          </p>
        </div>

        <a href="/" style={S.back}>← Back to Home</a>
      </div>
    </div>
  );
}
